(ns minorodata.global-search.api
  "HTTP layer for the kioku `/api/search` global-search endpoint.

  GET /api/search
    query      string (required) — substring matched against entity names / SQL
    types      vector of #{\"transform\" \"group\" \"source\" \"extract\" \"webform\"}
               (optional — omitted/empty searches all types)
    pagination {:items-per-page int :page int}
    sort       {:order-by #{\"name\" \"updated_at\" \"created_at\" \"type\"}
                :order-dir #{\"ASC\" \"DESC\"}}

  Response: {:results [{:type :id :name :description :metadata :updated_at :created_at} ...]
             :pagination {:items-per-page :page :total-pages}
             :sort {:order-by :order-dir}}"
  (:require [clojure.string :as cstr]
            [minorodata.app.utils :as utils]
            [mold-http.core :refer [reg-event-http]]))


(def default-items-per-page 20)

(def min-query-length 3)


(defn search-request [_ [{:keys [query types page items-per-page sort]}]]
  (when (>= (count query) min-query-length)
    {:http-xhrio
     {:id     :global-search
      :url    "/api/search"
      :params (utils/clean-up-query
               (utils/assoc-some
                {:query      (cstr/trim query)
                 :pagination {:items-per-page (or items-per-page default-items-per-page)
                              :page           (or page 1)}}
                :types (into [] (not-empty (vec types)))
                :sort  sort))}}))


(defn search-callback [_ [error response]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Search failed. Please try again."]}
    {:dispatch [:global-search/set-results response]}))


(reg-event-http
 :global-search.api/fetch
 search-request
 search-callback)
